import { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { Car } from '@/lib/types';
import { getAllCars } from '@/data/api';

interface CarsContextType {
  cars: Car[];
  loading: boolean;
  error: Error | null;
  refreshCars: () => Promise<void>;
}

const CarsContext = createContext<CarsContextType | undefined>(undefined);

export function CarsProvider({ children }: { children: ReactNode }) {
  const [cars, setCars] = useState<Car[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchCars = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getAllCars();
      setCars(data);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Feil ved henting av biler'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCars();
  }, []);

  return (
    <CarsContext.Provider value={{ cars, loading, error, refreshCars: fetchCars }}>
      {children}
    </CarsContext.Provider>
  );
}

export function useCars() {
  const context = useContext(CarsContext);
  if (context === undefined) {
    throw new Error('useCars må brukes innenfor en CarsProvider');
  }
  return context;
} 